<!--在线留言-->
<template>
  <div class="about-message">
    <div class="info-white flex-s-sb">
      <div class="msg-left">
        <div class="msg-en">contact us</div>
        <div class="msg-title">&nbsp;关于我们</div>
        <div class="msg-white">
          <div class="left-title">{{baseInfo.web_site_title}}</div>
          <div class="p-item flex-c">
            <div class="item-icon"><img class="img-block" src="../assets/icon_tel_red.png" alt=""></div>
            <div class="item-text">电话：{{baseInfo.web_tel}}</div>
          </div>
          <div class="p-item flex-c">
            <div class="item-icon"><img class="img-block" src="../assets/icon_mail_red.png" alt=""></div>
            <div class="item-text">邮箱：{{baseInfo.web_email}}</div>
          </div>
          <div class="p-item flex">
            <div class="item-icon"><img class="img-block" src="../assets/icon_address_red.png" alt=""></div>
            <div class="item-text">地址：{{baseInfo.web_address}}</div>
          </div>
          <div class="p-item flex-c">
            <div class="item-icon"><img class="img-block" src="../assets/icon_web.png" alt=""></div>
            <div class="item-text">网址：<a target="_blank" :href="baseInfo.web_home">{{baseInfo.web_home}}</a></div>
          </div>
        </div>
      </div>
      <div class="msg-right">
        <div class="msg-en flex-c-c">message</div>
        <div class="msg-title flex-c-c">在线留言</div>
        <el-form class="msg-form flex-wrap" :rules="msgRules" ref="messageForm" :model="messageForm" label-width="0">
          <el-form-item class="w100per" prop="content">
            <el-input class="w100per" type="textarea" :rows="7" v-model="messageForm.content" placeholder="请输入留言内容"></el-input>
          </el-form-item>
          <el-form-item class="w48per margin-right4per" prop="nickname">
            <el-input class="w100per" v-model="messageForm.nickname" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item class="w48per" prop="mobile">
            <el-input class="w100per" v-model="messageForm.mobile" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item class="w48per">
            <el-input class="w100per" v-model="messageForm.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <div class="form-btn flex-c-c" @click="handleConfirm('messageForm')">提 交</div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {ajaxPost,ajaxGet,ajaxUrl} from "../utils/ajax";

  export default {
    name: "MessageFrom",
    data(){
      return {
        ajaxUrl,
        messageForm:{},
        msgRules:{
          content: [
            { required: true, message: '请输入留言内容', trigger: 'change' }
          ],
          mobile: [
            { required: true, message: '请输入手机号码', trigger: 'change' }
          ],
          nickname: [
            { required: true, message: '请输入姓名', trigger: 'change' }
          ],
        },
        captchaObj: null, // 极验对象
        baseInfo: {},
      }
    },
    mounted() {
      this.initGt();
      this.fetchBase();
    },
    methods:{
      fetchBase(){
        ajaxGet({
          url: `${this.ajaxUrl}api/common/getConfig`,
          params:{},
          success(res){
            const {code, data, msg} = res;
            if(code === 200) {
              this.baseInfo = data.config_list;
            }
          },
        },this);
      },
      // 初始化极验验证
      initGt(){
        ajaxPost({
          url: `${ajaxUrl}api/common/geetest`,
          success(res) {
            const {code, data, msg} = res;
            if(code === 200) {
              initGeetest4({
                captchaId: data.captcha_id,
                product: 'bind',
              },  (captchaObj) =>{
                captchaObj.onReady(() => {
                  this.captchaObj = captchaObj;
                }).onSuccess(() => {
                  const validResult = captchaObj.getValidate();
                  if(validResult.captcha_id) {
                    ajaxPost({
                      url: 'ajaxMessage',
                      params:{
                        ...this.messageForm,
                        captcha_id: validResult.captcha_id,
                      },
                      success(res){
                        const {data, code, msg} = res;
                        if(code === 200){
                          this.$message.success('提交成功');
                          this.messageForm = {};
                          this.$refs['messageForm'].resetFields();
                        } else {
                          this.$message.warning(msg)
                        }
                      }
                    }, this)
                  } else {
                    this.$message.warning('请完成提交验证');
                  }
                })
              })
            } else {
              this.$message.warning(msg);
            }
          }
        }, this);
      },
      handleConfirm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.captchaObj.showCaptcha()
          } else {
            return false;
          }
        });
      }
    },
  }
</script>

<style scoped lang="scss">
  .about-message {
    width: 100%;background: url("../assets/message_bg.png") no-repeat center/cover;padding: 60px 47px;
    .info-white {
      width: 100%;padding: 40px 70px;background: rgba($color-white,.8);
      .msg-en { font-size: 60px;color: $theme-color;text-transform: uppercase;}
      .msg-title { font-size: 26px;color: $theme-color;line-height: 1;margin-top: -10px;letter-spacing: 1px;}
      .msg-left {
        flex: 0 0 407px;
        .msg-white {
          margin-top: 20px;width: 100%;background: $color-white;padding: 40px 20px 40px 50px;
          .left-title {font-size: 20px;color: $theme-color;letter-spacing: 1px;}
          .p-item {
            margin: 26px 0;width: 100%;padding-left: 2px;
            .item-icon { flex: 0 0 38px;}
            .item-text {
              font-size: $font-size16;color: rgba($theme-color,.9);
              a:hover { text-decoration: underline;}
            }
          }
        }
      }
      .msg-right {
        flex: 0 0 773px;
        .msg-form {
          margin-top: 20px;width: 100%;
          >>> .el-textarea__inner { border: none;padding: 12px 20px;font-size: $font-size16;}
          >>> .el-input__inner { border: none;height: 52px;padding: 10px 20px;font-size: $font-size16;}
          .form-btn { margin-top: 30px;width: 100%;height: 56px;background: $theme-color;color: $color-white;font-size: $font-size16;cursor: pointer;}
        }
      }
    }
  }
  .w48per { width: 48%;}
  .margin-right4per{ margin-right: 4%;}
  @media screen and (max-width: 750px) {
    .about-message {
      padding: 20px;
      .info-white {
        display: block;padding: 0;background: transparent;
        .msg-en { font-size: 36px;line-height: 1.3;display: block;}
        .msg-title { font-size: 22px;margin-top: 1px;display: block;}
        .msg-left {
          background: rgba(255,255,255,0.7);padding: 14px 12px;
          .msg-white {
            padding: 20px;
            .left-title { font-size: 16px;letter-spacing: 0;}
            .p-item {
              padding: 0;margin: 10px 0;
              .item-icon { margin-right: 10px;flex: 0 0 16px;.img-block { width: 100%;}}
              .item-text { font-size: 14px;}
            }
          }
        }
        .msg-right {
          width: 100%;background: rgba(255,255,255,0.7);margin-top: 20px;padding: 14px 12px;
          >>> .el-form-item { margin-bottom: 18px;}
          .msg-form {
            >>> .el-textarea__inner { height: 120px;font-size: 14px;padding: 12px;}
            >>> .el-input__inner { height: 40px;font-size: 14px;padding: 12px;}
            .form-btn { margin-top: 5px;height: 40px;font-size: 15px;border-radius: 4px;}
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MessageFrom.vue